import { axiosInstance, type CustomResponseFormat } from "api/instance";
import { PlanKey } from "../components/task/payment/planTypes";

export const PATIENT_DOMAIN = "patient";

export const PATIENT_LIST_ENDPOINT = "list";
export const PATIENT_TASK_UPDATE_REQUIRED_ENABLE_ENDPOINT =
  "task-update-required/enable";

export interface PatientType {
  patientId: number;
  nickname?: string;
  isHumanCheckRequired?: boolean;
  isTaskUpdateRequired?: boolean;
  isRemindRequired?: boolean;
  isRiskCheckRequired?: boolean;
  isExpirationNoticeRequired?: boolean;
  dayNumber?: number;
  expiryDaysLeft?: number;
  doneAt?: string;
  lastMessageSentAt?: string;
  coachName?: string;
  registeredAt?: string;
  isChatAvailable?: boolean;
  unreadMessageCount?: number;
  hasPraised?: boolean;
  surveySeq?: number;
  isNew?: boolean;
  plan?: PlanKey;
  currentUpdateCount?: number;
  totalUpdateCount?: number;
}

export const patientApi = {
  getPatientList: () =>
    axiosInstance.get<CustomResponseFormat<PatientType[]>>(
      `${PATIENT_DOMAIN}/${PATIENT_LIST_ENDPOINT}`
    ),
  enableTaskUpdateRequired: (pid: number) =>
    axiosInstance.get<void>(
      `${PATIENT_DOMAIN}/${PATIENT_TASK_UPDATE_REQUIRED_ENABLE_ENDPOINT}`,
      { params: { pid: pid } }
    ),
};
